import { post } from "../base.ehq.model";
import { deserialize } from "../base.serializer";
import { serialize } from "./unverified-user.serializer";

export const getUnverifiedUserToken = async (
  token,
  baseUrl,
  projectId,
  body
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/unverified_users`;
  try {
    const serializedBody = serialize(body);
    let res = await post(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
